import classNames from 'classnames'

import ImageRatio from '@/components/base/ImageRatio'
import Typography from '@/components/base/Typography'

import { WPImage } from '@/types'

export type Product = Partial<{
  link: string
  featuredImage: Partial<WPImage>
  title: {
    rendered: string
  }
}>

export type ProductCardProps = Product & {
  layout?: 'contained' | 'bordered'
}

const ProductCard = ({
  featuredImage,
  title,
  layout = 'bordered'
}: ProductCardProps) => {
  return (
    <span
      className={classNames(
        'grid gap-y-spacing-md rounded-radius-minimal py-spacing-sm ',
        {
          'border border-border-thumb-grid-light dark:border-border-thumb-grid-dark':
            layout === 'bordered'
        }
      )}
    >
      <ImageRatio
        src={featuredImage?.sizes?.large.url || featuredImage?.url || ''}
        alt={featuredImage?.alt || ''}
        ratio="4:5"
        fit="contain"
      />
      {title ? (
        <Typography
          variant="regular"
          className="flex justify-center text-text-secondary-light dark:text-text-secondary-dark"
        >
          {title.rendered}
        </Typography>
      ) : null}
    </span>
  )
}

export default ProductCard
